/**
 * Desk chassis — reusable Ant + token primitives.
 * Use these on every instrument surface. Do not invent a second kit.
 */

export { DeskChassis, DESK_EMPTY, DESK_CONTROL_SIZE } from './DeskChassis'
export type { DeskChassisProps } from './DeskChassis'
export {
  DeskButton,
  DeskInput,
  DeskInputNumber,
  DeskSelect,
  DeskSwitch,
  DeskSegmented,
  DeskTabs,
} from './DeskControls'
export { DeskReadout, DeskReadoutRow } from './DeskReadout'
export type {
  DeskReadoutProps,
  DeskReadoutRowProps,
  DeskReadoutTone,
  DeskReadoutEmphasis,
} from './DeskReadout'
export { DeskChip, DeskSideChip } from './DeskChip'
export type { DeskChipProps, DeskChipTone, DeskSide } from './DeskChip'
export { DeskStatus } from './DeskStatus'
export type { DeskStatusProps } from './DeskStatus'
